import Shepherd from 'shepherd.js';

const initialButtons = [
	{
		action() {
			return this.cancel();
		},
		classes: 'shepherd-button-secondary',
		text: 'Salir'
	},
	{
		action() {
			return this.next();
		},
		text: 'Siguiente'
	}
];

const middleButtons = [
	{
		action() {
			return this.cancel();
		},
		classes: 'shepherd-button-secondary',
		text: 'Salir'
	},
	{
		action() {
			return this.back();
		},
		text: 'Anterior'
	},
	{
		action() {
			return this.next();
		},
		text: 'Siguiente'
	}
];

const lastButtons = [
	{
		action() {
			return this.back();
		},
		text: 'Anterior'
	},
	{
		action() {
			return this.cancel();
		},
		classes: 'shepherd-button-secondary',
		text: 'Salir'
	}
];
 // ---------------------------------------------------------- NAV TUTORIAL 01----------------------------------------------------------
export const mainSteps : Shepherd.Step.StepOptions[] = [
  {
		id: 'start',
		title: '¡Bienvenido! ',
		text: 'En esta solución, podrás gestionar visualmente todos tus activos de manera fácil y eficiente.',
		attachTo: {
			element: '',
		},
		buttons: initialButtons,
	},
	{
		id: 'step1',
		title: 'Panel de Módulos',
		text: 'En este panel encontrarás los módulos más utilizados, como el Control de Activos (donde puedes ver todos tus activos), Rutas, Alarmas, Geocercas y mucho más. ¡Todo lo que necesitas para una gestión completa al alcance de tu mano!',
		attachTo: {
			element: '#sideBarNav',
			on: 'right'
		},
		buttons: initialButtons,
	},
	// {
	// 	id: 'step2',
	// 	title: 'Barra de Notificaciones',
	// 	text: 'Aquí podrás visualizar las notificaciones de tus activos, manteniéndote siempre informado sobre su estado y cualquier evento relevante.',
	// 	attachTo: {
	// 		element: '#fullNav',
	// 		on: 'bottom'
	// 	},
	// 	buttons: middleButtons,
	// },
	{
		id: 'step3',
		title: 'Empresa Activa',
		text: 'Aquí podrás visualizar la empresa seleccionada actualmente.',
		attachTo: {
			element: '#customerSelectNav',
			on: 'bottom'
		},
		buttons: middleButtons,
	},
	{
		id: 'step4',
		title: 'Notificaciones de Aplicación',
		text: 'Este botón te muestra las notificaciones del día de hoy. Los colores de las notificaciones varían según su origen.',
		attachTo: {
			element: '#notificationsButtonNav',
			on: 'bottom'
		},
		buttons: middleButtons,
	},
	{
		id: 'step5',
		title: 'Alarmas activas',
		text: 'Muestra las alarmas más importantes, como las relacionadas con Geocercas de Seguridad, Valet Parking, entre otras.',
		attachTo: {
			element: '#alarmsButtonNav',
			on: 'bottom'
		},
		buttons: lastButtons,
	}
];

// ---------------------------------------------------------- PANEL LOCATIONS TUTORIAL----------------------------------------------------------
export const panelLocationSteps : Shepherd.Step.StepOptions[] = [
	{
		  id: 'start',
		  title: 'Control de Activos',
		  text: 'Este módulo te permite visualizar los activos de la empresa, organizándolos en pestañas, cada una con funciones específicas que explicaremos por separado.',
		  attachTo: { element: '#panelLocationContainer', 
			on: 'right' },
		  buttons: initialButtons,
	  },
	  {
		  id: 'step1',
		  title: 'Buscador de activos',
		  text: 'Aquí podrás buscar tus activos utilizando su ID o Alias para una localización rápida y precisa.',
		  attachTo: {
			  element: '#searchLocationInput',
			  on: 'right'
		  },
		  buttons: middleButtons,
	  },
	  {
		  id: 'step2',
		  title: 'Filtros de activos',
		  text: 'Botón para filtrar activos según características en común, facilitando la búsqueda y gestión.',
		  attachTo: {
			  element: '#panelLocationFilterButton',
			  on: 'bottom'
		  },
		  buttons: middleButtons,
	  },
	  {
		  id: 'step3',
		  title: 'Botones de opciones',
		  text: 'Ésta cinta contiene botones para ejecutar acciones grupales .',
		  attachTo: {
			  element: '#panelLocationButtonToolContainer',
			  on: 'right'
		  },
		  buttons: middleButtons,
	  },
	  {
		  id: 'step4',
		  title: 'Reportes',
		  text: 'Al hacer clic, se despliega la lista de reportes disponibles que puedes descargar en formato Excel',
		  attachTo: {
			  element: '#panelLocationReportsButton',
			  on: 'right'
		  },
		  buttons: middleButtons,
	  },
	//   {
	// 	  id: 'step5',
	// 	  title: 'Pestaña de activos actualizados',
	// 	  text: 'Esta pestaña muestra los autos que han actualizado su posición en las últimas 12 horas.',
	// 	  attachTo: {
	// 		  element: '#panelLocationActiveTab',
	// 		  on: 'bottom'
	// 	  },
	// 	  buttons: middleButtons,
	//   },
	//   {
	// 	  id: 'step6',
	// 	  title: 'Pestaña de activos desactualizados',
	// 	  text: 'Esta pestaña muestra los autos cuya última actualización ha llegado hace más de 12 horas.',
	// 	  attachTo: {
	// 		  element: '#panelLocationInactiveTab',
	// 		  on: 'bottom'
	// 	  },
	// 	  buttons: middleButtons,
	//   },
	//   {
	// 	  id: 'step7',
	// 	  title: 'Pestaña de activos sin reporte',
	// 	  text: 'Esta pestaña muestra los autos que nunca han recibido una posición por parte del GPS.',
	// 	  attachTo: {
	// 		  element: '#panelLocationDisconectedTab',
	// 		  on: 'bottom'
	// 	  },
	// 	  buttons: middleButtons,
	//   },
	  {
		  id: 'step5',
		  title: 'Lista de activos',
		  text: 'Aquí puedes visualizar los activos organizados según sus categorías.',
		  attachTo: {
			  element: '#panelLocationTabContent',
			  on: 'right'
		  },
		  buttons: middleButtons,
	  },
	  {
		  id: 'step6',
		  title: 'Herramienta de Selección de Identificadores',
		  text: 'Puedes seleccionar los activos dentro de un polígono específico y realizar acciones generales con ellos, o copiar sus identificadores para uso posterior.',
		  attachTo: {
			  element: '#vinSelectorTool',
			  on: 'bottom'
		  },
		  buttons: lastButtons,
	  }
  ];


  // ---------------------------------------------------------- PANEL DETAIL LOCATIONS TUTORIAL----------------------------------------------------------
export const panelDetailLocationSteps : Shepherd.Step.StepOptions[] = [
	  {
		  id: 'step1',
		  title: 'Acciones Individuales',
		  text: 'Aquí podrás ejecutar acciones sobre el activo seleccionado.',
		  attachTo: {
			  element: '#individualToolsBar',
			  on: 'bottom'
		  },
		  buttons: middleButtons,
	  },
	  {
		  id: 'step2',
		  title: 'Menú De Detalle',
		  text: 'Aquí podrás ejecutar otras acciones menos comunes para el activo, como la descarga de reportes, acceder a históricos, entre otras.',
		  attachTo: {
			  element: '#reportListButton',
			  on: 'right'
		  },
		  buttons: middleButtons,
	  },
	  {
		  id: 'step4',
		  title: 'Detalle de Activo',
		  text: 'Aquí te mostraremos todos los detalles de tu activo, así como la información asociada a él.',
		  attachTo: {
			  element: '.tab-group',
			  on: 'right'
		  },
		  buttons: lastButtons,
	  }
  ];

  // ---------------------------------------------------------- PANEL CONTROL RUTAS TUTORIAL----------------------------------------------------------
export const panelRouteControlSteps : Shepherd.Step.StepOptions[] = [
	{
		  id: 'start',
		  title: 'Control de Rutas',
		  text: 'Este módulo te permite visualizar las rutas de tus activos, buscalo por fechas y su identificador. Una vez localizado, puedes realizar las acciones de control de rutas.',
		  attachTo: { element: '#panelRoutes', 
			on: 'right' },
		  buttons: initialButtons,
	  }
  ];


  export const panelRouteResumeSteps : Shepherd.Step.StepOptions[] = [
	{
		  id: 'step1',
		  title: 'Resúmen de Ruta',
		  text: 'Presenta un resúmen rápido de ruta, dependiendo del tipo de activo seleccionado.',
		  attachTo: { element: '#panelRouteResumeTabContent', 
			on: 'right' 
			},
		  scrollTo: false,
		  buttons: [
			{
				text: 'Siguiente',
				action() {
					const element = document.querySelector('#routeResumeStepsTab') as HTMLElement;
					console.log("tutorial",element);
					
					if (element) {
					  element.click();
					}
					return this.next();
				}
			  }
		  ],
	  },
	  {
		id: 'step2',
		title: 'Trazabilidad de Ruta',
		text: 'Éncontrarás la ruta separada por cambios de estatus reportados por el activo.',
		attachTo: {
			element: '#routeResumeStepsTab',
			on: 'right'
		},
		scrollTo: false,
		buttons: [
			{
				action() {
					return this.cancel();
				},
				classes: 'shepherd-button-secondary',
				text: 'Salir'
			},
			{
				text: 'Anterior',
				action() {
					const element = document.querySelector('#routeResumeTab') as HTMLElement;
					console.log("tutorial",element);
					
					if (element) {
					  element.click();
					}
					return this.back();
				}
			  },
			{
				action() {
					return this.next();
				},
				text: 'Siguiente'
			}
		  ],
		},
		{
		  id: 'step3',
		  title: 'Trazabilidad de Ruta',
		  text: 'Podrás seleccionar cada trayecto para ir al momento específico en el mapa.',
		  attachTo: {
			  element: '#routeStepsContent',
			  on: 'right'
		  },
		  scrollTo: false,
		  buttons: lastButtons,
	  	}
  ];

    // ---------------------------------------------------------- PANEL GEOCERCAS TUTORIAL----------------------------------------------------------
export const panelGeofencesSteps : Shepherd.Step.StepOptions[] = [
	  {
		id: 'step1',
		title: 'Acciones de Geocercas',
		text: 'Aquí podrás llevar a cabo las acciones grupales más comunes para las geocercas.',
		attachTo: { element: '#panelGeofencesButtonTool', 
		  on: 'right' },
		buttons: initialButtons,
	},{
		id: 'step2',
		title: 'Control de Geocercas',
		text: 'Aquí encontrarás las geocercas que has registrado, organizadas según su estado de activación.',
		attachTo: { element: '#panelGeofencesTabs', 
		  on: 'right' },
		buttons: lastButtons,
	},
  ];


  export const panelGeofenceDetailSteps : Shepherd.Step.StepOptions[] = [
	{
		  id: 'step1',
		  title: 'Acciones de Geocercas',
		  text: 'Aquí podrás ejecutar las acciones individuales más comunes para la geocerca seleccionada.',
		  attachTo: { element: '#panelDetailGeofencesTool', 
			on: 'bottom' },
			scrollTo: false,
			canClickTarget: false,
		  buttons: initialButtons,
	  },
	  {
		id: 'step2',
		title: 'Detalle de Geocerca',
		text: 'Aquí podrás ver el detalle de la geocerca seleccionada, también podrás ver los activos que tiene asignados.',
		attachTo: {
			element: '#panelDetailGeofencesData',
			on: 'right'
		},
		scrollTo: false,
		buttons: lastButtons,
		}
  ];
  
  export const panelAddGeofence : Shepherd.Step.StepOptions[] = [
	{
		  id: 'step1',
		  title: 'Crear o editar Geocerca',
		  text: 'Se pueden crear figuras geometricas que representan un espacio en el mapa.',
		  attachTo: { element: '#panelAddGeofenceTabContent', 
			on: 'right' 
			},
		  scrollTo: false,
		  canClickTarget: false,
		  buttons: initialButtons,
	  },
	  {
		id: 'step2',
		title: 'Locaciones',
		text: 'En esta sección se buscan y agregan locaciones que se van a asociar a la geocerca, una vez asociadas, se pueden eliminar.',
		attachTo: {
			element: '.addGeofenceIdentifiersTabContent',
			on: 'right'
		},
		scrollTo: false,
		canClickTarget: false,
		buttons: middleButtons,
	  },
	  {
		id: 'step3',
		title: 'Buscar locaciones',
		text: 'Busca las locaciones por identificador, si agregas una coma, puedes añadir más de un identificador a la vez con el botón "Agregar seleccionados".',
		attachTo: {
			element: '#addGeofenceIdentifiersSearcher',
			on: 'right'
		},
		scrollTo: false,
		canClickTarget: false,
		buttons: middleButtons,
	  },
	  {
		id: 'step4',
		title: 'Locaciones agregadas',
		text: 'Aquí se ven las locaciones ya asociadas y se pueden eliminar presionando el botón "X".',
		attachTo: {
			element: '#addGeofenceIdentifiersList',
			on: 'right'
		},
		scrollTo: false,
		canClickTarget: false,
		buttons: [
			{
				action() {
					return this.cancel();
				},
				classes: 'shepherd-button-secondary',
				text: 'Salir'
			},
			{
				action() {
					return this.back();
				},
				text: 'Anterior'
			},
			{
				text: 'Siguiente',
				action() {
					const element = document.querySelector('#addGeofenceGeometryTab') as HTMLElement;
					console.log("tutorial",element);
					
					if (element) {
					  element.click();
					}
					setTimeout(() => {
						return this.next();
					}, 500);
				}
			}
		  ],
		},
		{
			id: 'step5',
			title: 'Configurar la geometria',
			text: 'Aqui puedes crear la figura que representará la geocerca y colocarla en el mapa.',
			attachTo: {
				element: '.addGeofenceGeometryTabContent',
				on: 'right'
			},
			scrollTo: false,
			canClickTarget: false,
			buttons: [
				{
					action() {
						return this.cancel();
					},
					classes: 'shepherd-button-secondary',
					text: 'Salir'
				},
				{
					text: 'Anterior',
					action() {
						const element = document.querySelector('#addGeofenceIdentifiersTab') as HTMLElement;
						
						if (element) {
						  element.click();
						}
						return this.back();
					}
				  },
				{
					action() {
						return this.next();
					},
					text: 'Siguiente'
				}
			],
		},
		{
			id: 'step6',
			title: 'Estado de la Geocerca',
			text: 'Si desactivas la geocerca, no recibiras notificaciones o alarmas de la geocerca.',
			attachTo: {
				element: '#addGeofenceGeometryStatus',
				on: 'right'
			},
			scrollTo: false,
			canClickTarget: false,
			buttons: middleButtons,
		},
		{
			id: 'step7',
			title: 'Tipos de Geocerca',
			text: 'Puedes seleccionar dos tipos de geocercas, las que te alarman/notifican cuando sale un activo, o las que alarman cuando entra.',
			attachTo: {
				element: '#addGeofenceGeofenceTypes',
				on: 'right'
			},
			scrollTo: false,
			canClickTarget: false,
			buttons: middleButtons,
		},
		{
			id: 'step8',
			title: 'Categorias de Geocerca',
			text: 'Selecciona que representa la goecerca, una zona de monitoreo, seguridad, valet parking, etc.',
			attachTo: {
				element: '#addGeofenceGeofenceCategories',
				on: 'right'
			},
			scrollTo: false,
			canClickTarget: false,
			buttons: middleButtons,
		},
		{
			id: 'step9',
			title: 'Tipos de geometrias',
			text: 'Selecciona que figura tendrá la geocerca, hay disponibles Buffer (círculo) y polígono.',
			attachTo: {
				element: '#addGeofenceGeometryType',
				on: 'right'
			},
			scrollTo: false,
			canClickTarget: false,
			buttons: middleButtons,
		},
		{
			id: 'step10',
			title: 'Buffer (Círculo)',
			text: 'Es el seleccionado por defecto, es un círculo que se expande desde el punto activo, una vez hagas clic en el mapa para definir dicho punto, se presentarán opciones para cambiar el tamaño del diametro.',
			attachTo: {
				element: '#addGeofenceGeometryTypeBuffer',
				on: 'top'
			},
			scrollTo: false,
			canClickTarget: false,
			buttons: middleButtons,
		},
		{
			id: 'step11',
			title: 'Polígono',
			text: 'Te permite seleccionar varios vertices en el mapa. Una vez que haya más de tres, sea crea un polígono. Tras terminar de seleccionar los vertices, has doble clic sobre el poligono que creaste para que se finalice.  \n \n  Podrás ver tu resultado final de colo azul!',
			attachTo: {
				element: '#addGeofenceGeometryTypePolygon',
				on: 'top'
			},
			scrollTo: true,
			canClickTarget: false,
			buttons: middleButtons,
		},
		{
		  id: 'step12',
		  title: 'Guardar',
		  text: 'Después de nombrar tu geocerca y darle forma, no olvides guardarla! \n \n  (puedes guardar desde cualquier sección)).',
		  attachTo: {
			//   element: '#id="addGeofenceSaveButton"',
			//   on: 'right'
		  },
		  scrollTo: true,
		  canClickTarget: false,
		  buttons: lastButtons,
	  	}
  ];